/**
 * Matches 1:1 with "credit_card" repo under:
 * product/dashboard/src/hooks/useAccountPasswordValidation.tsx
 *
 * Please make sure all changes match up
 */
import * as React from "react";

import {
  isValid as isValidPassword,
  minimumLength,
  validate,
  hasLowercaseLetter,
  hasUppercaseLetter,
} from "./password";

export const validationMessages = {
  passwordTooShort: "Your password needs at least 8 characters",
  genericInvalid: "Your password is invalid",
  passwordRequiresLowercase:
    "Your password needs at least 1 lowercase character",
  passwordRequiresUpperscase:
    "Your password needs at least 1 uppercase character",
};

type UseAccountPasswordValidationOutput = {
  validationMessage: string;
  isValid: boolean;
};

export const accountPasswordValidation = (password: string) => {
  const validationResult = validate(password);
  const isValid = isValidPassword(password);

  let validationMessage = "";

  if (password.length < minimumLength) {
    validationMessage = validationMessages.passwordTooShort;
  } else if (!hasLowercaseLetter(password)) {
    validationMessage = validationMessages.passwordRequiresLowercase;
  } else if (!hasUppercaseLetter(password)) {
    validationMessage = validationMessages.passwordRequiresUpperscase;
  } else if (validationResult.feedback.warning) {
    validationMessage = validationResult.feedback.warning;
  } else if (!isValid) {
    validationMessage = validationMessages.genericInvalid;
  }

  return { validationMessage, isValid };
};

export function useAccountPasswordValidation(
  password: string,
): UseAccountPasswordValidationOutput {
  // TODO: centralize password validation and feedback logic in library so it
  // can be shared between website and dashboard Right now the logic is subtly
  // different, and we can end up in place where a password could be valid when
  // they signed up but deemed invalid when they try to change it
  return React.useMemo(() => {
    return accountPasswordValidation(password);
  }, [password]);
}
